import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// --- Configuration from Environment Variables ---
const firebaseConfig = {
  apiKey: "AIzaSyC0Q_GgMzULNsIAqWEXeQmJeqwlYcv-VLg",
  authDomain: "hostitdotcom.firebaseapp.com",
  projectId: "hostitdotcom",
  storageBucket: "hostitdotcom.firebasestorage.app",
  messagingSenderId: "465959687453",
  appId: "1:465959687453:web:1a130ab9a0b21b8e18fdf4",
  measurementId: "G-6MLGKM52H7"
};

// Note: In a real production app, it's best to move these to a .env file 
// (e.g., process.env.REACT_APP_STRIPE_KEY) instead of hardcoding them.
export const STRIPE_PUBLISHABLE_KEY = "pk_test_51Rr9o1DUQZFl2xlY47Qr5moxvpH7rmcBcejKHssTIj0tYSmO0OYf6d9CeiaNVEz5XXUy3e7wEQjiuYMSRIZcQG7J00KUO50oF6";
export const MAPS_API_KEY = "AIzaSyBrwtHQkona0RJCkqGcJcDDg_7PfBVC4bY";
export const GEMINI_API_KEY = "";

// --- Initialize Firebase Services ---
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

export default app;